<page-header (showBlockedChanged)="loadAgain()"></page-header>

<div id="heading-wrapper">
   
    <div id="h1-wrapper">
        <h1>נוספו לאחרונה</h1>
        <img src="../../../assets/images/triangular.png" (click)="serShowH2()" alt="showDetails"
            [ngStyle]="{'transform': showH2 ? 'rotate(0deg)' : 'rotate(90deg)'}" />
    </div>
    <h2 [ngStyle]="{'visibility': showH2 ? 'visible' : 'hidden'}">כאן מופיעים כל הסרטונים המשוייכים לחשבון שלך ממאגרי
        האתרים הכלליים,<br>
        בקשות פרטיות, וכלל הסרטונים הנקיים שנוספו בתקופה האחרונה. (סרטונים ישנים לא משוייכים לחשבונך)</h2>
</div>
<videos *ngIf="videos.length" [videos]="videos" class="videos"></videos>
<div class="loading-div" *ngIf="videos.length==0&&loading">
    <div class="d-flex justify-content-center">
        <div class="spinner-border large-spinner" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    <span>אנחנו טוענים עבורך את הסרטונים...</span>
</div>

<div *ngIf="loading&&videos.length>0" class="bottom-spinner">
    <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>